<template>
  <div class="tile is-ancestor">
    <div class="tile is-vertical is-12">
      <div
        v-if="selectedOrder"
        class="tile is-parent"
      >
        <article class="tile is-child box">
          <nav
            class="breadcrumb is-medium"
            aria-label="breadcrumbs"
          >
            <ul class="">
              <li v-if="$route.matched[0].meta.schoolType !== 'eschool'">
                <router-link :to="{ name: 'highschool-categories'}">
                  {{ $t('shop.offers.list') }}
                </router-link>
              </li>
              <li v-else>
                <router-link :to="{ name: 'eshop-categories'}">
                  {{ $t('shop.offers.list') }}
                </router-link>
              </li>
              <li class="is-active">
                <a class="has-text-weight-light title is-5">{{ $t('shop.cart.epreferences') }}</a>
              </li>
            </ul>
            <hr>
          </nav>

          <section>
            <div v-for="candidate in candidates">
              <transition
                name="component-fade"
                mode="out-in"
              >
                <component
                  :is="schoolingItemsView"
                  :candidate="candidate"
                  :order="selectedOrder"
                />
              </transition>
            </div>
            <div>
              <transition
                name="component-fade"
                mode="out-in"
              >
                <component
                  :is="offerItemsView"
                  :order="selectedOrder"
                />
              </transition>
            </div>
            <footer class="box m-t-lg">
              <div class="card-footer-item is-size-4">
                <div>
                  <i>{{ $t('offers.cart.price') }} :</i>
                  <strong>{{ selectedOrder.payment_total > 0 ? selectedOrder.payment_total:0 }} {{ selectedOrder.payment_currency }}</strong>
                  <div
                    v-if="selectedOrder.credits.length"
                    class="subtitle is-italic"
                  >
                    <div v-for="credit in selectedOrder.credits">
                      <span v-if="credit.type.code === 'credit'">
                        Avoir utilisé de <strong>{{ credit.amount }} €</strong>
                      </span>
                      <span v-else>
                        Réduction appliquée de <strong>{{ credit.amount }} € </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="selectedOrder.promoCodes.length"
                class="m-b-sm"
              >
                <promo-code-display
                    :promo="selectedOrder.promoCodes[0]"
                    :has-fees="selectedOrder.order_status === 'complete'"
                />
              </div>
            </footer>
          </section>

          <section
            id="payment-view"
            class="box"
          >
            <transition
              name="component-fade"
              mode="out-in"
            >
              <component
                :is="paymentView"
                :school="school"
                :order="selectedOrder"
                :candidate="candidates[0]"
                :candidates="candidates"
                :guarantor="guarantor"
                @send="savePayment"
                @edit="editPayment"
              />
            </transition>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import OrderPayments from '../payment/OrderEditPayments.vue'
    import OrderConfirmation from '../payment/OrderConfirmation.vue'
    import SchoolingItemsView from './SchoolingItems'
    import OfferItemsView from './OfferItems'
    import PromoCodeDisplay from "../../../application/PromoCodeDisplay.vue";

    export default {
      components: {PromoCodeDisplay},
        props: {
            candidates: {type: Array}
        },
        data() {
            return {
                schoolingItemsView: SchoolingItemsView,
                offerItemsView: OfferItemsView,
                paymentView: OrderConfirmation,
                checkboxContract: false,
                guarantor: null,
            }
        },
        computed: {
            ...mapGetters(
                'orders', [
                    'checkedoutOrders',
                    'checkedoutOrder',
                    'selectedOrder',
                    'completeOrder'
                ]
            ),
            ...mapGetters(
                'organization', [
                    'getSchoolBySlug'
                ]
            ),
            school() {
                return this.getSchoolBySlug(this.$route.params.school)
            }
        },
        methods: {
            ...mapActions(
                'orders', [
                    'selectOrder'
                ]
            ),
            savePayment() {
                this.paymentView = OrderConfirmation
                this.$scrollTo('#payment-view', { offset: -10 }, 200)
            },
            editPayment() {
                this.paymentView = OrderPayments
            },
        },
        created() {
            if (this.$route.name === 'highschool-order' || this.$route.name === 'eshop-order') {
                if (this.completeOrder(parseInt(this.$route.params.orderId))) {
                    this.selectOrder(this.completeOrder(parseInt(this.$route.params.orderId)))
                }
                if (this.checkedoutOrder(parseInt(this.$route.params.orderId))) {
                    this.selectOrder(this.checkedoutOrder(parseInt(this.$route.params.orderId)))
                }
            }


        }
    }
</script>

<style scoped>

</style>
